import React from 'react';

const StripeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="17"
    viewBox="0 0 38 17"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1186_95827)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.7376 9.31697C37.7376 6.65205 36.4467 4.54927 33.9796 4.54927C31.5021 4.54927 30.0031 6.65205 30.0031 9.29615C30.0031 12.4295 31.7727 14.0118 34.3127 14.0118C35.5515 14.0118 36.4884 13.7307 37.1962 13.3352V11.2532C36.4884 11.6071 35.6764 11.8257 34.6458 11.8257C33.6361 11.8257 32.7408 11.4718 32.6263 10.2434H37.7167C37.7167 10.1081 37.7376 9.5668 37.7376 9.31697ZM32.5951 8.32803C32.5951 7.15172 33.3134 6.66246 33.9692 6.66246C34.6042 6.66246 35.2808 7.15172 35.2808 8.32803H32.5951ZM25.9849 4.54927C24.9647 4.54927 24.3089 5.02812 23.9445 5.36123L23.8092 4.71583H21.5191V16.8537L24.1215 16.302L24.1319 13.356C24.5067 13.6266 25.0584 14.0118 25.9745 14.0118C27.8378 14.0118 29.5346 12.5128 29.5346 9.21287C29.5242 6.19402 27.8066 4.54927 25.9849 4.54927ZM25.3603 11.7216C24.7461 11.7216 24.3818 11.503 24.1319 11.2324L24.1215 7.37033C24.3922 7.06844 24.7669 6.86025 25.3603 6.86025C26.3076 6.86025 26.9634 7.92205 26.9634 9.28574C26.9634 10.6807 26.318 11.7216 25.3603 11.7216ZM17.9381 3.93509L20.5509 3.37296V1.25977L17.9381 1.81149V3.93509ZM17.9381 4.72624H20.5509V13.8348H17.9381V4.72624ZM15.1378 5.49656L14.9713 4.72624H12.7228V13.8348H15.3252V7.6618C15.9394 6.86025 16.9804 7.00599 17.3031 7.12049V4.72624C16.97 4.60132 15.752 4.3723 15.1378 5.49656ZM9.93293 2.4673L7.39293 3.00862L7.38252 11.3469C7.38252 12.8875 8.53801 14.0222 10.0787 14.0222C10.9323 14.0222 11.5569 13.8661 11.9004 13.6787V11.5655C11.5673 11.7008 9.92252 12.1797 9.92252 10.639V6.94353H11.9004V4.72624H9.92252L9.93293 2.4673ZM2.89589 7.37033C2.89589 6.96435 3.22901 6.8082 3.78073 6.8082C4.57187 6.8082 5.57121 7.04762 6.36236 7.47443V5.02812C5.49835 4.6846 4.64474 4.54927 3.78073 4.54927C1.66753 4.54927 0.262207 5.65271 0.262207 7.49525C0.262207 10.3684 4.21794 9.91033 4.21794 11.1491C4.21794 11.6279 3.80155 11.7841 3.2186 11.7841C2.35458 11.7841 1.25114 11.4302 0.376715 10.9513V13.4288C1.34483 13.8452 2.32335 14.0222 3.2186 14.0222C5.38384 14.0222 6.87244 12.95 6.87244 11.0866C6.86203 7.98451 2.89589 8.53623 2.89589 7.37033Z"
        fill="#646F87"
      />
    </g>
    <defs>
      <clipPath id="clip0_1186_95827">
        <rect
          width="38"
          height="16.0769"
          fill="white"
          transform="translate(0 0.922852)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default StripeIcon;
